/**
 * Goafreet Smart Guide: Deterministic Content Registry
 * Phase A implementation. Do not hallucinate URLs; all items must point to existing canonical routes.
 */

export const SMART_GUIDE_REGISTRY = [
  // --- E-COMMERCE & AMAZON TOOLS ---
  {
    id: "amazon-acos-calculator",
    title: "Amazon ACoS Calculator",
    path: "/tools/amazon/acos-calculator",
    type: "calculator",
    description: "Calculate your Amazon Advertising Cost of Sales and profitability.",
    aliases: ["acos", "amazon ads", "ppc calculator", "advertising cost"],
    goals: ["calculate profit", "reduce ad spend", "optimize amazon"],
    industry: "ecommerce"
  },
  {
    id: "amazon-fba-calculator",
    title: "Amazon FBA Fee Calculator",
    path: "/tools/amazon/fba-fee-calculator",
    type: "calculator",
    description: "Estimate FBA fees based on product dimensions and weight.",
    aliases: ["fba fee", "fulfillment by amazon", "fba calculator"],
    goals: ["calculate profit", "launch product"],
    industry: "ecommerce"
  },
  
  // --- DESIGN & CREATIVE TOOLS ---
  {
    id: "color-picker",
    title: "Color Picker Studio",
    path: "/tools/color-picker",
    type: "tool",
    description: "Extract, generate, and visualize color palettes.",
    aliases: ["color palette", "hex code", "color extractor", "colors"],
    goals: ["design brand", "build website", "create graphics"],
    industry: "all"
  },
  {
    id: "contrast-checker",
    title: "Accessibility Contrast Checker",
    path: "/tools/contrast-checker",
    type: "tool",
    description: "Ensure your text and background colors meet WCAG accessibility standards.",
    aliases: ["contrast", "wcag", "accessibility", "readable"],
    goals: ["design brand", "build website"],
    industry: "all"
  },
  
  // --- SOCIAL MEDIA & MARKETING TOOLS ---
  {
    id: "reel-script-studio",
    title: "Reel Script Studio",
    path: "/tools/social-media/reel-script-studio",
    type: "tool",
    description: "Generate engaging scripts for Instagram Reels and TikToks.",
    aliases: ["reels", "tiktok script", "video script", "short form video"],
    goals: ["grow social media", "create content", "marketing strategy"],
    industry: "creator"
  },
  {
    id: "instagram-caption-generator",
    title: "Instagram Caption Generator",
    path: "/tools/instagram-caption-generator/",
    type: "tool",
    description: "AI-powered Instagram caption writing.",
    aliases: ["caption", "ig caption", "write caption"],
    goals: ["grow social media", "create content"],
    industry: "creator"
  },
  
  // --- SEO TOOLS ---
  {
    id: "meta-tag-generator",
    title: "SEO Meta Tag Generator",
    path: "/tools/seo/meta-tag-generator",
    type: "tool",
    description: "Generate optimized HTML meta tags for better search engine rankings.",
    aliases: ["meta tags", "seo tags", "title tag", "search engine optimization"],
    goals: ["improve seo", "build website", "marketing strategy"],
    industry: "all"
  },

  // --- EDUCATIONAL RESOURCES & CASE STUDIES ---
  {
    id: "website-design-facts",
    title: "Facts About Website Designing",
    path: "/facts-about-website-designing",
    type: "article",
    description: "Crucial statistics and insights about modern web design and UX.",
    aliases: ["web design facts", "website ux", "ui design"],
    goals: ["learn web design", "build website"],
    industry: "all"
  },
  {
    id: "industry-insights",
    title: "Industry Insights & Case Studies",
    path: "/industry-insights",
    type: "research",
    description: "Deep dive case studies on major social media accounts and marketing strategies.",
    aliases: ["case study", "insights", "marketing research", "strategy"],
    goals: ["learn marketing", "explore case studies"],
    industry: "all"
  },
  {
    id: "instagram-design",
    title: "Instagram Design Inspirations",
    path: "/instagram-design",
    type: "portfolio",
    description: "Curated grid inspirations for the salon and creative industries.",
    aliases: ["instagram layout", "grid design", "visual inspiration"],
    goals: ["design brand", "grow social media"],
    industry: "creator"
  },

  // --- SERVICES ---
  {
    id: "service-web-dev",
    title: "Website & App Development Services",
    path: "/services", 
    type: "service",
    description: "Professional development for custom web applications and e-commerce stores.",
    aliases: ["hire developer", "build my website", "app development", "agency"],
    goals: ["request professional assistance", "build website"],
    industry: "all"
  },
  {
    id: "service-digital-marketing",
    title: "Digital Marketing & SEO Services",
    path: "/digital-marketing",
    type: "service",
    description: "Comprehensive marketing strategies, SEO optimization, and ad management.",
    aliases: ["hire marketer", "run ads", "seo agency", "social media management"],
    goals: ["request professional assistance", "grow company"],
    industry: "all"
  }
];
